export const _sgoFr = {
    sgo: 'Système de gestion des opérations',
    noMission: 'Aucune intervention',
    response: 'Engagement',
    followUp: 'Suivi',
    logBook: 'Mains courantes',
    hideHistory: 'Cacher l\'historique',
    showHistory: 'Afficher l\'historique',
    closeMission: 'Clôturer la mission',
    confirmCloseMission: 'Êtes-vous sûr de vouloir clôturer cette mission ?',
    propose: 'Proposer',
    send: 'Envoyer',
    modify: 'Modifier',
    search: 'Rechercher',
    manageVehiclesToSend: 'Gestion des moyens à envoyer',
    engage: 'Engager',
    manning: 'Armement',
    removeVehicle: 'Retirer le véhicule',
    confirmRemoveVehicle: 'Retirer le véhicule de l\'intervention ?',
    removeReason: 'Raison du retrait',
    empty: 'Vide',
    pull: 'Retirer',
    messageSent: 'Message envoyé',
    notifications: 'Notifications',
    vehicles: 'Véhicules',
    vehicle: 'Véhicule',
    acknowledge: 'Acquitter',
    requestAcknowledged: 'Demande acquittée',
    addedBy: 'ajouté par',
    added: 'ajouté',
    onFunction: 'sur la fonction',
    deleted: 'supprimé',
    qualificationAlert: 'Qualification de l\'alerte par',
    cancelledReason: 'Raison de l\'annulation',
    alertUpdated: 'Alerte mise à jour',
    addedToVehicle: 'ajouté au véhicule',
    onSkill: 'sur la compétence',
    pulledOutVehicle: 'retiré du véhicule',
    status: 'Statut',
    start: 'Départ',
    unavailable: 'Indisponible',
    unManning: 'Manque de personnel',
    functionNotFound: 'Fonction non trouvée',
    cancelledStart: 'Départ annulé',
    message: 'Message',
    deadlineExceeded: 'Délai dépassé',
};

export const _sgoEn = {
    sgo: 'Operations management system',
    noMission: 'No mission',
    response: 'Response',
    followUp: 'Follow-up',
    logBook: 'Log book',
    hideHistory: 'Hide history',
    showHistory: 'Show history',
    closeMission: 'Close mission',
    confirmCloseMission: 'Are you sure you want to close this mission?',
    propose: 'Propose',
    send: 'Send',
    modify: 'Modify',
    search: 'Search',
    manageVehiclesToSend: 'Manage vehicles to send',
    engage: 'Engage',
    manning: 'Manning',
    removeVehicle: 'Remove vehicle',
    confirmRemoveVehicle: 'Remove vehicle from the intervention?',
    removeReason: 'Reason for removal',
    empty: 'Empty',
    pull: 'Pull',
    messageSent: 'Message sent',
    notifications: 'Notifications',
    vehicles: 'Vehicles',
    vehicle: 'Vehicle',
    acknowledge: 'Acknowledge',
    requestAcknowledged: 'Request acknowledged',
    addedBy: 'added by',
    added: 'added',
    onFunction: 'on function',
    deleted: 'deleted',
    qualificationAlert: 'Qualification of the alert by',
    cancelledReason: 'Reason for cancellation',
    alertUpdated: 'Alert updated',
    addedToVehicle: 'added to vehicle',
    onSkill: 'on skill',
    pulledOutVehicle: 'pulled out from vehicle',
    status: 'Status',
    start: 'Start',
    unavailable: 'Unavailable',
    unManning: 'Lack of personnel',
    functionNotFound: 'Function not found',
    cancelledStart: 'Start cancelled',
    message: 'Message',
    deadlineExceeded: 'Deadline exceeded',
};

export const _sgoDe = {
    sgo: 'Betriebsführungssystem',
    noMission: 'Kein Eingriff',
    response: 'Reaktion',
    followUp: 'Folgen',
    logBook: 'Logbuch',
    hideHistory: 'Geschichte verbergen',
    showHistory: 'Geschichte anzeigen',
    closeMission: 'Mission schließen',
    confirmCloseMission: 'Sind Sie sicher, dass Sie diese Mission schließen möchten?',
    propose: 'Vorschlagen',
    send: 'Senden',
    modify: 'Ändern',
    search: 'Suche',
    manageVehiclesToSend: 'Fahrzeuge zum Senden verwalten',
    engage: 'Engagieren',
    manning: 'Besatzung',
    removeVehicle: 'Fahrzeug entfernen',
    confirmRemoveVehicle: 'Fahrzeug aus dem Eingriff entfernen?',
    removeReason: 'Grund für die Entfernung',
    empty: 'Leer',
    pull: 'Ziehen',
    messageSent: 'Nachricht gesendet',
    notifications: 'Benachrichtigungen',
    vehicles: 'Fahrzeuge',
    vehicle: 'Fahrzeug',
    acknowledge: 'Quittieren',
    requestAcknowledged: 'Anfrage wurde berücksichtigt',
    addedBy: 'hinzugefügt von',
    added: 'hinzugefügt',
    onFunction: 'auf Funktion',
    deleted: 'gelöscht',
    qualificationAlert: 'Qualifikation des Alarms durch',
    cancelledReason: 'Grund für die Stornierung',
    alertUpdated: 'Alarm aktualisiert',
    addedToVehicle: 'hinzugefügt zum Fahrzeug',
    onSkill: 'auf Fähigkeit',
    pulledOutVehicle: 'aus dem Fahrzeug gezogen',
    status: 'Status',
    start: 'Start',
    unavailable: 'Nicht verfügbar',
    unManning: 'Personalmangel',
    functionNotFound: 'Funktion nicht gefunden',
    cancelledStart: 'Start abgebrochen',
    message: 'Nachricht',
    deadlineExceeded: 'Frist überschritten',
};
